// extracted by mini-css-extract-plugin
export default {"overFlow":"_1JbaAnBCMviEvUBc75WsSI","mainTableWidget":"_2cif1rOV45k4BiwP3vv-Uj"};